import { Dispatch } from "redux";

import api from "@helpers/api";

import { AssetStateAction } from "@reducers/types/inventory/asset-state";

import { GET_ASSET } from "./types";
const endPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}/settings`;

export const fetchAssets = (query: any) => async (
  dispatch: Dispatch<AssetStateAction>
) => {
  dispatch({ type: GET_ASSET.LOADING, payload: true });

  try {
    const res = await api.get(`${endPoint}/product-name`, {
      params: query,
    });

    const { data, page, size, total } = res.data || {};

    dispatch({
      type: GET_ASSET.SUCCESS,
      payload: {
        data,
        pagination: {
          page,
          size,
          total,
        },
      },
    });
  } catch (err) {
    dispatch({ type: GET_ASSET.ERROR, payload: null });
  }
};
